import React, { memo } from 'react';
import styled from 'styled-components';
import TextField from '@cld/text-field';
import { useColorSync } from '../hooks/useColorSync';
import { validatedHex } from '../colorPickerUtils';

export const StyledHex = styled(TextField)`
  input {
    text-transform: uppercase;
  }
`;

export const HexInput = memo(({ onChange, value, size }) => {
  const { localState: hexInputState, handleBlur: handleHexBlur, handleChange: handleHexChange } = useColorSync({
    watchedValue: value,
    onChange,
    validationFn: validatedHex,
    view: 'hex',
  });
  return (
    <StyledHex
      type="text"
      value={hexInputState.toUpperCase()}
      onBlur={handleHexBlur}
      onChange={handleHexChange}
      size={size}
      data-test-specifier="color-input"
    />
  );
});
